export const locale = {
  LISTS: {
  NoData: "Veri yok",
  NoDataFound: "Veri bulunamadı",
  NoDataFoundFor: "{a} için veri bulunamadı",
  NoPhoneNumber: "Numara bulunamadı",
  NoPostalCode: "Posta kodu bulunamadı",
  AddANumber: "Hiç numara eklenmedi.",
  City: "Şehir",
  AddedBefore: "Daha önce eklendi",
},
  dashboard_origin: "Gösterge Paneli",
  menu: "Menü",
  get_menu_again: "Menüyü Yeniden Al",
  loading_error: {
    title: "Yükleme Hatası!",
    message: "Veriler yüklenirken hata oluştu! Lütfen tekrar deneyin",
    text: "Tekrar Dene",
  },
  copy_right: {
    year: "1404",
    text1:
      "Bu sistemin tüm maddi ve manevi hakları korunmakta olup, reklam şirketine aittir",
    text2: "En İyi Girişimciler",
    text3: "Sehr Arad, herhangi bir kopyalama yasal takibe tabidir.",
  },
  user: "Değerli Kullanıcı",
  hi: "Merhaba",
  exit: "Çıkış",
  go_to_page: "Sayfaya Git",
  show: "Göster",
  until: "kadar",
  from: "den",
  page: "sayfa",
  notes: "Notlar",
  created_at: "Oluşturma Tarihi",
  registration: "Kayıt",
  edit_contact: "Kişiyi Düzenle",
  cancel: "İptal",
  edit: "Düzenle",
  delete: "Sil",
  contact_info: "İletişim Bilgileri",
  add_birthday: "Doğum Tarihi Ekle",
  contacts: "Telefon Rehberleri",
  last_updated_at: "Son Güncelleme",
  added_to_contact: "Kişilere eklendi",
  contact_registered: "Kişiniz kaydedilmedi.",
  transaction: "İşlem",
  write_message: "Mesaj Yaz",
  note_title: "Not Başlığı",
  create_note: "Not Ekle",
  are_you_sure_to_delete: "Silmek istediğinizden emin misiniz?",
  last_transaction: "Son İşlemler",
  your_balance: "Bakiyeniz",
  no_transaction: "Henüz bir işlem kaydınız yok!",
  increase_balance: "Bakiye Artır",
  transaction_list: "İşlem Listesi",
  withdraw: "Para Çekme",
  decrease: "Para Çekme",
  deposit: "Para Yatırma",
  increase: "Para Yatırma",
  charge: "Cüzdan Şarj Et",
  refund: "İade",
  save: "Kaydet",
  reload: "Listeyi Yenile",
  shared: "Paylaşılan",
  list: "Liste",
  single_add: "Tekli Ekle",
  mass_add: "Toplu Ekle",
  excel_add: "Excel Ekle",
  added_successfully: "Başarıyla eklendi",
  error_add_phone: "Numara eklerken hata",
  group: {
    add: "Yeni Grup Ekle",
    delete: "Grubu Sil",
    edit: "Grubu Düzenle",
    first: "Önce yeni bir grup ekleyin.",
  },
  successfully_deleted: "Başarıyla silindi",
  notification: {
    text: "Kullanıcı Bildirimleri",
    new: "Yeni Mesaj",
    messages: "Mesajlar",
    events: "Etkinlikler",
    no_new_message: "Yeni mesaj yok!",
    show_all: "Tümünü Göster",
    no_new_event: "Yeni etkinlik yok!",
    go_to_user: "Kullanıcıya Git",
    watched: "Görüldü",
  },
  locking_for_service: "Hangi hizmeti arıyorsunuz?",
  service_name: "İstediğiniz hizmet adını girin...",
  invite: {
    title: "Sistemi arkadaşlarınıza tanıtın.",
    gift: "Hediye",
    get: "Al.",
    phone: "Numarayı girin.",
    invite: "Davet Et!",
    got_it: "Anladım",
    get_gift: "Hediye Al",
    success: "Davet mesajınız başarıyla gönderildi.",
    wrong_number: "Lütfen doğru numara girin.",
  },
  ticker: {
    text: "Her an yanınızdayız...",
    help: "Destek ekibimizle iletişim için bilet kaydedin",
    register: "Bilet Kaydet",
  },
  package: {
    title: "Aktif Paketler",
    no: "Aktif paketiniz yok.",
    no_limit: "Sınırsız Panel",
    day: " günlük",
    other: " diğer",
    expiration: "Son ",
    expired: "Süresi dolmuş ",
  },
  Loading: {
    Waiting: "Lütfen bekleyin",
    Description: "Birkaç saniye bekleyin",
  },
  Questions: {
    Yes: "Evet",
    No: "Hayır",
  },
  Success: {
    Title: "Başarılı",
    defaultActionText: "Anladım",
  },
  Info: {
    Title: "Bilgilendirme",
    defaultActionText: "Anladım",
  },
  Warning: {
    Title: "Dikkat",
    defaultActionText: "Anladım",
  },
  Error: {
    Title: "Hata",
    defaultActionText: "Anladım",
  },
  Wallet: {
    Title: "Yetersiz Bakiye",
    defaultActionText: "Anladım",
  },
  ConnectionLost: {
    Title: "İnternet bağlantınız kesildi",
    Subtitle: "Lütfen internet bağlantınızı kontrol edin",
    Button: "Tekrar Dene",
  },
  emoji: "Emoji",
  text_suggest_free: "Metin Danışmanı (ücretsiz)",
  select_campaign: "Kampanya Seç",
  short_link: "Kısa Bağlantı",
  text_suggest: "Metin Danışmanı",
  select_emoji: "Emoji Seç",
  default_text: "Varsayılan Metin",
  emoji_group: {
    "Smileys & Emotion": "İfadeler ve Duygular",
    "People & Body": "İnsanlar ve Vücut",
    "Animals & Nature": "Hayvanlar ve Doğa",
    "Food & Drink": "Yiyecek ve İçecek",
    "Travel & Places": "Seyahat ve Yerler",
    Activities: "Aktiviteler",
    Objects: "Nesneler",
    Symbols: "Semboller",
    Flags: "Bayraklar",
  },
  table: {
    index: "Sıra",
    title: "Başlık",
    text: "Metin",
    select: "Seç",
    next: "İleri",
    previous: "Geri",
    rows_per_page: "Sayfa başına satır",
    no_data: "Gösterilecek veri yok",
    search_placeholder: "Ara",
  },
  modal: {
    success: "Başarı",
  },
  actions: {
    remove: "Kaldır",
    copyLink: "Bağlantıyı Kopyala",
    operations: "İşlemler",
    edit: "Düzenle",
    delete: "Sil",
    show: "Göster",
    accept: "Onayla",
    reject: "Reddet",
    enable: "Etkinleştir",
    download: "İndir",
    deactive: "Devre Dışı Bırak",
  },

  shortLink: {
    freeShorten: 'Bağlantılarınızı "ücretsiz" kısaltın.',
    clickToSelect: "Seçmek için istediğiniz bağlantıya tıklayın.",
    create: "Kısa Bağlantı Oluştur",
    title: "Başlık",
    titleHint: "Kısa bağlantı için bir isim ekleyin.",
    link: "Bağlantı",
    linkHint: "İstediğiniz bağlantıyı girin.",
    shortenedLink: "Kısaltılmış Bağlantı",
    clickCount: "Tıklama Sayısı",
    selectDomain: "Alan Adı Seç",
  },
  pagination: {
    next: "İleri",
    previous: "Geri",
    rowsPerPage: "Sayfa başına satır",
    noData: "Gösterilecek veri yok",
    search: "Ara",
  },
  validation: {
    titleRequired: "Başlık zorunludur",
    minLength4: "En az 4 karakter",
    linkRequired: "Bağlantı zorunludur",
    mustIncludeHttps: "https:// içermelidir",
    invalidLink: "Lütfen doğru bağlantı girin.",
  },
  messages: {
    addedSuccessfully: "Başarıyla eklendi.",
    confirmDeleteShortLink: "Kısa bağlantıyı silmeyi onayla?",
  },
  inputMenu: {
    text: "Metin",
    selectUserInfo: "Kullanıcı Bilgilerini Seç",
  },
  patternDialog: {
    title: "Şablon/Kampanya Seç",
    change: "Şablon/Kampanya Değiştir",
    createPattern: "Yeni Şablon Kaydet",
    createCampaign: "Yeni Kampanya Kaydet",
    tabs: {
      pattern: "Şablon Seç",
      campaign: "Kampanya Seç",
    },
    empty: "Şablon bulunamadı, önce bir şablon kaydedin.",
    columns: {
      id: "Kimlik",
      type: "Tür",
      pattern: "Şablon",
      static: "Sabit",
      title: "Başlık",
      content: "Metin",
      status: "Durum",
      rejected: "Reddedildi",
      approved: "Onaylandı",
    },
    pagination: {
      next: "İleri",
      prev: "Geri",
      rowsPerPage: "Sayfa başına satır",
      noData: "Gösterilecek veri yok",
      search: "Ara",
    },
  },
  PATTERN: {
    SELECTED_MESSAGE: "Seçilen Mesaj:",
    REQUIRED_INPUTS: "Zorunlu Alanlar:",
    SELECTED_CAMPAIGN: "Seçilen Kampanya:",
    CAMPAIGN_ID: "Kimlik",
    PRE_NAME: "Ön Ad",
    NAME: "Ad",
    MIDDLE_NAME: "Orta Ad",
    LAST_NAME: "Soyad",
    POST_NAME: "Son Ad",
    ALIAS: "Takma Ad",
    COMPANY: "Şirket",
    JOB_TITLE: "İş Ünvanı",
    PHONE: "Telefon",
    BIRTHDAY: "Doğum Tarihi",
    DESCRIPTION: "Açıklama",
  },
  CONTACT_GROUP: {
    LIST: "Liste",
    ADD: "Ekle",
    SEARCH: "Ara",
    INDEX: "Sıra",
    ID: "Kimlik",
    GROUP_NAME: "Grup Adı",
    PARENT: "Üst",
    CREATE: {
      GROUP_NAME: "Varsayılan Grup Adı",
      PARENT_CATEGORY: "Üst Kategori",
      ADD_GROUP: "Grup Ekle",
      SUCCESS: "Varsayılan grup başarıyla eklendi.",
      ERROR: "Varsayılan grup eklenirken hata!",
      SEARCH: "Ara",
      TITLE: "Başlık",
      SEARCH_IN_TITLE: "Başlıkta Ara",
      FROM: "Den",
      TO: "Kadar",
      BIRTHDAY_FROM: "Doğum Tarihi den",
      BIRTHDAY_TO: "kadar",
      ITEMS_PER_PAGE: "Sayfa başına öğe",
      PHONE_COPY: "Numara Kopyala",
      COPY_PHONE: "Numara Kopyala",
      DELETE_CONTACT_GROUP: "Kişiyi Gruptan Sil",
      DELETE_FROM_GROUP_ONLY: "Kişi sadece bu gruptan silinsin",
      DELETE_FROM_ALL_GROUPS: "Kişi tüm gruplardan silinsin",
      USER: "Kullanıcı",
      PHOTO: "Fotoğraf",
      FULL_NAME: "Ad ve Soyad",
      EMAIL: "E-posta",
      PHONE_NUMBER: "Telefon Numarası",
      JOB_TITLE_COMPANY: "İş Ünvanı ve Şirket",
      CREATED_AT: "Oluşturma Zamanı",
      PHONEBOOK: "Telefon Rehberi",
      ACTIONS: "İşlemler",
    },
    TITLE: "Başlık",
    SEARCH_IN_TITLE: "Başlıkta Ara",
    FROM: "Den",
    TO: "Kadar",
    BIRTHDAY_FROM: "Doğum Tarihi den",
    BIRTHDAY_TO: "kadar",
    ITEMS_PER_PAGE: "Sayfa başına öğe",
    PHONE_COPY: "Numara Kopyala",
    COPY_PHONE: "Numara Kopyala",
    DELETE_CONTACT_GROUP: "Kişiyi Gruptan Sil",
    DELETE_FROM_GROUP_ONLY: "Kişi sadece bu gruptan silinsin",
    DELETE_FROM_ALL_GROUPS: "Kişi tüm gruplardan silinsin",
    USER: "Kullanıcı",
    PHOTO: "Fotoğraf",
    FULL_NAME: "Ad ve Soyad",
    EMAIL: "E-posta",
    PHONE_NUMBER: "Telefon Numarası",
    JOB_TITLE_COMPANY: "İş Ünvanı ve Şirket",
    CREATED_AT: "Oluşturma Zamanı",
    PHONEBOOK: "Telefon Rehberi",
    ACTIONS: "İşlemler",
  },
  GRADUAL: {
    SEND_GRADUAL: "Kademeli Gönderim",
    ALLOWED_HINT: "500'den fazla numara için",
    SEND_GRADUAL_OPTION: "Kademeli gönder",
    AFTER_EVERY: "Her",
    SEND_SMS: "SMS gönderilsin?",
    TIME_INTERVAL: "Zaman Aralığı",
    SMS_PART: "SMS Sayısı",
    SMS_PART_HINT: "Her gönderim partisindeki SMS sayısını girin.",
    COUNT_ERROR: "Her partideki SMS sayısı 500'den az olamaz!",
  },
  HISTORY: {
    CREATE_NEW: "Yeni Geçmiş Oluştur",
    BACK: "Geri",
    TITLE: "Geçmiş Başlığı",
    STEP: "Adım",
    LAST_CALL: "Son Arama Zamanı",
    DISCUSSIONS: "Yapılan Görüşmeler",
    REMIND_DATE: "Hatırlatma Zamanı",
    FOLLOWUP: "Sonraki Aramda Takip Edilecekler",
    SAVE_HISTORY: "Geçmişi Kaydet",
    INDEX: "Sıra",
    SAVED_BY: "Kaydeden",
    ACTION: "Yönetim",
    MORE_INFO: "Hakkında daha fazla bilgi",
    CREATE_ERROR: "Müşteri geçmişi eklenirken hata!",
  },
  FORMS: {
    SourceNumber: "Kaynak Numara",
    DestinationPhone: "Hedef Numara",
    Add: "Ekle",
    SEND_TO_SELECTED_NUMBERS: "Seçilen Numaralara Gönder",
    CHANGE_PATTERN_CAMPAIGN: "Şablon/Kampanya Değiştir",
    SendTime: "Gönderim Zamanı",
    SELECTED_MESSAGE: "Seçilen Mesaj",
    REQUIRED_INPUTS: "Zorunlu Alanlar",
    SELECTED: "Seçildi",
    ID: "Kimlik",
    SEND: "Gönder",
    DATE_REQUIRED: "Tarih seçimi zorunludur.",
    TIME_INTERVAL: "Zaman Aralığı",
    TIME_INTERVAL_FROM_PREVIOUS: "Önceki Mesajdan Zaman Aralığı",
    Title: "Başlık",
    LINK: "Bağlantı",
    LINK_HINT: "herhangi",
    LINK_PLACEHOLDER: "Örnek:[](https://example.ex/any)",
    LINK_SHORTENED_HINT:
      "Bağlantınız kısaltıldıktan sonra 14 karakterle (example.ex/any) metinde yer alacak ve her mesaj için benzersiz bağlantı gönderilecek.",
    Text: "Metin",
    MUST_INCLUDE_PATTERN: "{pattern} ifadesini içermelidir",
    INVALID_LINK: "Doğru bağlantı girin",
  },
  ERRORS: {
    VpnDetectedTitle: "VPN'inizi kapatın",
    VpnDetectedSubtitle:
      "Bu, sistemin daha iyi çalışmasını sağlar ve daha iyi deneyim yaşarsınız.",
    PhoneIsNotValid: "Telefon numarası geçersiz",
    MaxPhoneLimit: "50.000'den fazla numara ekleyemezsiniz.",
    NoSelectedLineNumber: "Kaynak numara seçilmedi.",
    INVALID_TIMER: "Doğru zaman girin",
    NoAccess: "Erişiminiz yok",
    PleaseBuyAPlane: "Lütfen bir plan satın alın",
    NoAccountCharge: "Hesap bakiyesi yetersiz",
    PleaseChargeYourAccount: "Lütfen hesabınızı şarj edin",
    Unauthorized: "Erişim yok: lütfen tekrar giriş yapın",
    ServerError: "Sunucu hatası, lütfen daha sonra deneyin",
    NetworkError: "Ağ hatası: internet bağlantınızı kontrol edin",
    InvalidInput: "Geçersiz giriş",
    SessionExpired: "Oturum süresi doldu, lütfen tekrar giriş yapın",
    TokenInvalid: "Geçersiz token",
    VpnDetected: "VPN'iniz açık, lütfen kapatın",
    RequestTimeout: "İstek zaman aşımına uğradı, lütfen tekrar deneyin",
    DuplicateEntry: "Bu zaten kayıtlı",
  },

  BUTTONS: {
    DELETE_NUMBERS: "Numaraları Sil",
    ADD_BULK: "Toplu Ekle",
    FROM_FILE: "Dosyadan",
    More: "Daha Fazla",
    BuyAPlane: "Plan Satın Al",
    AccountCharge: "Hesap Şarj Et",
    OK: "Tamam",
    Close: "Kapat",
    Cancel: "İptal",
    Retry: "Tekrar Dene",
    Login: "Giriş",
    Logout: "Çıkış",
    Save: "Kaydet",
    Submit: "Gönder",
  },
  GENERAL: {
    row: "Sıra",
    id: "Kimlik",
    back: "Geri",
    manage: "Yönet",
    SENDING: "Gönderiliyor",
    RELOAD: "Yenile",
    PRINT: "Yazdır",
    DELETE: "Sil",
    SUBMIT: "Gönder",
    SUCCESSFULLY_ADDED: "Başarıyla eklendi",
    RELOAD: "Yenile",
    CANCEL: "İptal",
    SUCCESSFULLY_DOWNLOADED: "Başarıyla indirildi",
    Loading: "Yükleniyor...",
    NoData: "Veri bulunamadı",
    Welcome: "Hoş Geldiniz",
    Profile: "Profil",
    Settings: "Ayarlar",
    Wallet: "Cüzdan",
    Dashboard: "Gösterge Paneli",
  },

  NOTICES: {
    Attention: "Dikkat Edin",
    MinimumSendWarning:
      '"Haber Gönderimi" kaynak numarası ile gönderimde minimum sayı {{number}} olmalıdır.',
  },
  contactsTags: {
    select_group: "Grup Seç",
    create_group: "Grup Oluştur",
    search: "Ara",
    add_group: "Grup Ekle",
    enter_group_name: "İstediğiniz adı girin",
    group_name: "Grup Adı",
    cancel: "İptal",
    edit: "Düzenle",
    save: "Kaydet",
    loading_categories: "Kategoriler yükleniyor...",
    select_group_and_subgroup: "Grup ve Alt Grup Seç",
    add_group_with_subgroups: "Grup alt gruplarla eklensin",
    add_group_only: "Sadece seçilen grup eklensin",
    duplicate_name_error: "Ad zaten var",
    added_successfully: "Başarıyla eklendi.",
    confirm_delete_group: "Grubu silmeyi onayla?",
    deleted_successfully: "Başarıyla silindi",
    edited_successfully: "Başarıyla düzenlendi",
    group_added_successfully: "Seçilen gruplar başarıyla eklendi.",
    error_creating_group: "Varsayılan grup eklenirken hata",
    create_default_group: "Varsayılan Grup Oluştur",
    select_default_group: "Varsayılan Grup Seç",
    add_custom_group: "Özel Adlı Grup Ekle",
  },
  CONTACT_SHARE: {
    ADD_PHONE_NUMBER: "Telefon Numarası Ekle",
    ADD: "Ekle",
    SHARE_ACCESS:
      "Aşağıdakilerden herhangi birini seçerek istediğiniz erişimi başkalarıyla paylaşın.",
    SELECT_ACCESS: "Telefon Rehberi için erişim seç",
    DELETE: "Sil",
    EDIT: "Düzenle",
    SEND: "Gönder",
    PERSONS_WITH_ACCESS: "Erişimi Olan Kişiler",
    REMOVE_ACCESS: "Erişimi Kaldır",
    RETURN: "Geri",
    SAVE_CHANGES: "Değişiklikleri Kaydet",
    SHARE_CONTACT_BOOK: "Telefon Rehberini Paylaş",
    PHONE_VALIDATION: "Doğru telefon numarası girin",
    SUCCESS_SHARE: "Telefon rehberi başarıyla paylaşıldı.",
    ERROR_SHARE: "Telefon rehberi paylaşılırken hata!",
    PHONE_DUPLICATE: "Numara zaten eklendi!",
    CHANGES_SAVED: "Değişiklikler başarıyla kaydedildi.",
    ERROR_SAVING_CHANGES: "Değişiklikler kaydedilirken hata!",
  },
  CONTACT_SEARCH: {
    SEARCH: "Ara",
    ADD_NUMBER: "Numara Ekle",
  },
  CONTACT_PAGINATION: {
    PER_PAGE: "Sayfa başına",
    FROM: "Den",
    TO: "Kadar",
    TOTAL: "Toplam",
  },
  SUCCESS: {
    DELETED: "Başarıyla silindi",
    SUCCESS: "Başarı",
  },
  CONFIRM: {
    DELETE_BULK: "Kaydedilmemiş numaraları sil?",
  },
  TOOLTIP: {
    CopyPhoneNumbers: "Numaralarınızı kopyalayın ve tıklayın",
    COPY_LINK: "Bağlantıyı Kopyala",
    COPY_NUMBER: "Numarayı Kopyala",
    SEE_PROFILE: "Profili Görüntüle",
  },
  CONTACT_EDIT: {
    EDIT: "Düzenle",
    DELETE: "Sil",
  },
  CONTACT_MENU: {
    SHARE: "Paylaş",
    PRINT: "Yazdır",
    EXCEL_EXPORT: "Excel'e Aktar",
    DELETE: "Sil",
    SUCCESS_DELETE: "Başarıyla silindi.",
    ERROR_DELETE: "Kişiler silinirken hata!",
  },
  CONTACTS: {
    PREFIX: "Ön Ek",
    NAME: "Ad",
    MIDDLENAME: "Orta Ad",
    LASTNAME: "Soyad",
    POSTFIX: "Son Ek",
    ALIAS: "Takma Ad",
    COMPANY: "Şirket",
    JOBTITLE: "İş Ünvanı",
    PHONE: "Telefon",
    PHONE_PLACEHOLDER: "Örnek: 8070 111 13 (989)(989+)(9)(09)",
    ADD_EMAIL: "E-posta Ekle",
    EMAIL: "E-posta",
    ADD_ADDRESS: "Adres Ekle",
    ADDRESS: "Adres",
    PROVINCE: "İl",
    CITY: "Şehir",
    POSTALCODE: "Posta Kodu",
    YEAR_OPTIONAL: "Yıl (isteğe bağlı)",
    MONTH: "Ay",
    DAY: "Gün",
    ADD_BIRTHDAY: "Doğum Tarihi Ekle",
    ADD_WEBSITE: "Web Sitesi Ekle",
    WEBSITE: "Web Sitesi",
    ADD_DATE: "Tarih Ekle",
    DATE: "Tarih",
    CUSTOM_FIELD: "Özel Alan",
    ADD_CUSTOM_FIELD: "Özel Alan Ekle",
    NOTE: "Açıklama",
    ADD_NOTE: "Not Ekle",
    HOME: "Ev",
    WORK: "İş",
    OTHER: "Diğer",
    PROFILE: "Profil",
    BLOG: "Blog",
    HOMEPAGE: "Ana Sayfa",
    TITLE: "Başlık",
    BIRTHDAY_ERROR: "Tarihi doğru girin",
    YEAR_ERROR: "4 haneli",
    EMAIL_ERROR: "E-postayı doğru girin",
    WEBSITE_ERROR: "Bağlantıyı doğru girin (website.com)",
    PHONE_ERROR: "Doğru telefon numarası girin",
    ADD_HISTORY: "Geçmiş Ekle",
    HISTORY_LIST: "Geçmiş Listesi",
    EDIT_CONTACT: "Kişiyi Düzenle",
    SHOW_CONTACT: "Kişiyi Göster",
  },
  MONTHS: {
    FARVARDIN: "Farvardin",
    ORDIBEHESHT: "Ordibeheşt",
    KHORDAD: "Khordad",
    TIR: "Tir",
    MORDAD: "Mordad",
    SHAHRIVAR: "Şehrivar",
    MEHR: "Mehr",
    ABAN: "Aban",
    AZAR: "Azar",
    DEY: "Dey",
    BAHMAN: "Bahman",
    ESFAND: "Esfand",
  },

  UPLOAD_EXCEL: {
    DOWNLOAD_SAMPLE: "Örnek Excel dosyasını indir ve kullan",
    UPLOAD_TITLE: "Dosya Yükle",
    DRAG_DROP_TEXT_PART1: "Yüklemek için sürükle bırak veya",
    DRAG_DROP_TEXT_PART2: "buraya",
    DRAG_DROP_TEXT_PART3: "tıklayın",
    FILE_INPUT_LABEL: "Excel Dosyası Yükle",
  },
  SUCCESS_MESSAGE: {
    LINK_COPIED: "Bağlantı başarıyla kopyalandı!",
  },
  ERROR_MESSAGE: {
    COPY_LINK_FAILED: "Bağlantı kopyalanırken hata.",
  },
  POPUP: {
    TITLE_OR_BUTTON_TEXT: "Şablon/Kampanya Seç",
    BUTTON_EDIT_TEXT: "Şablon/Kampanya Değiştir",
  },
  BUTTON: {
    REGISTER_NEW_PATTERN: "Yeni Şablon Kaydet",
    REGISTER_NEW_CAMPAIGN: "Yeni Kampanya Kaydet",
    CREATE_NEW_HISTORY: "Yeni Geçmiş Oluştur",
    SAVE_HISTORY: "Geçmişi Kaydet",
    SELECT_GROUP: "Grup Seç",
    CREATE_GROUP: "Grup Oluştur",
    ADD_GROUP: "Grup Ekle",
    SAVE: "Kaydet",
    CREATE_GROUP_SINGULAR: "Grup Oluştur",
    ADD: "Ekle",
    SEND: "Gönder",
    EDIT_PERMISSIONS: "Düzenle",
    GO_BACK: "Geri",
    SAVE_CHANGES: "Değişiklikleri Kaydet",
    GUIDE: "Rehber",
    START: "Başla",
    EDIT: "Düzenle",
    CANCEL: "İptal",
    AUTO_REFRESH: "Otomatik Yenileme",
    AUTO_REFRESH_SETTINGS: "Otomatik Yenileme Ayarları",
    BACK: "Geri",
  },
  TABS: {
    SELECT_PATTERN: "Şablon Seç",
    SELECT_CAMPAIGN: "Kampanya Seç",
    LIST: "Liste",
    ADD: "Ekle",
    ADD_CUSTOM_GROUP: "Özel Adlı Grup Ekle",
    SELECT_DEFAULT_GROUP: "Varsayılan Grup Seç",
  },
  NO_DATA: {
    NO_PATTERN: "Şablon bulunamadı, önce bir şablon kaydedin.",
  },
  TABLE: {
    ID: "Kimlik",
    TYPE: "Tür",
    PATTERN: "Şablon",
    STATIC: "Sabit",
    TITLE: "Başlık",
    TEXT: "Metin",
    STATUS: "Durum",
    REJECTED: "Reddedildi",
    ACCEPTED: "Onaylandı",
    NEXT_BUTTON: "İleri",
    PREVIOUS_BUTTON: "Geri",
    ROWS_PER_PAGE_TEXT: "Sayfa başına satır",
    NO_DATA_TEXT: "Gösterilecek veri yok",
    PLACEHOLDER_SEARCH: "Ara",
    MORE_INFO_ABOUT_ITEM: "{name} hakkında daha fazla bilgi",
  },
  MENU_ITEMS: {
    TEXT_INPUT: "Metin",
    SELECT_USER_INFO: "Kullanıcı Bilgilerini Seç",
  },
  TABLE_CONTROLS: {
    COUNT: "Sayı",
    SEARCH: "Ara",
  },
  FORM_LABELS: {
    DEFAULT_GROUP_NAME: "Varsayılan Grup Adı",
    PARENT_CATEGORY: "Üst Kategori",
    HISTORY_TITLE: "Geçmiş Başlığı",
    STEP: "Adım",
    LAST_CALL_TIME: "Son Arama Zamanı",
    NEGOTIATIONS: "Yapılan Görüşmeler",
    REMINDER_TIME: "Hatırlatma Zamanı",
    FOLLOW_UP_ITEMS: "Sonraki Aramda Takip Edilecekler",
    GROUP_NAME: "Grup Adı",
    SEARCH: "Ara",
    TITLE: "Başlık",
    SEARCH_IN_TITLE: "Başlıkta Ara",
    FROM: "Den",
    TO: "Kadar",
    BIRTHDAY_FROM: "Doğum Tarihi den",
    BIRTHDAY_TO: "kadar",
    COUNT: "Sayı",
    ADD_PHONE_NUMBER: "Telefon Numarası Ekle",
  },
  TOAST: {
    Success: "İşlem başarıyla tamamlandı",
    Error: "Hata oluştu",
    Warning: "Uyarı: lütfen girişleri kontrol edin",
    AUTO_REFRESH_STARTED: "Otomatik yenileme başladı.",
    DEFAULT_GROUP_SUCCESS: "Varsayılan grup başarıyla eklendi.",
    DEFAULT_GROUP_ERROR: "Varsayılan grup eklenirken hata!",
    ADD_HISTORY_ERROR: "Müşteri geçmişi eklenirken hata!",
    DUPLICATE_NAME: "Ad zaten var",
    TAG_ADDED_SUCCESS: "Etiket başarıyla eklendi.",
    TAG_DELETED_SUCCESS: "Etiket başarıyla silindi",
    TAG_EDITED_SUCCESS: "Etiket başarıyla düzenlendi",
    GROUPS_ADDED_SUCCESS: "Seçilen gruplar başarıyla eklendi.",
    ADD_GROUP_ERROR: "Varsayılan grup eklenirken hata!",
    PHONE_COPIED_SUCCESS: "Telefon numarası kopyalandı.",
    SUCCESSFULLY_DELETED: "Başarıyla silindi",
    ERROR_DELETING_CONTACT_FROM_PHONEBOOK:
      "Kişi telefon rehberinden silinirken hata!",
    SHARE_SUCCESS: "Telefon rehberi başarıyla paylaşıldı.",
    SHARE_ERROR: "Telefon rehberi paylaşılırken hata!",
    NUMBER_ALREADY_ADDED: "Numara zaten eklendi!",
    CHANGES_SAVED_SUCCESS: "Değişiklikler başarıyla kaydedildi.",
    CHANGES_SAVE_ERROR: "Değişiklikler kaydedilirken hata!",
  },
  HEADERS: {
    GRADUAL_SEND: "Kademeli Gönderim",
    GRADUAL_SEND_HINT: "(500'den fazla numara için)",
  },
  CHECKBOX_LABELS: {
    GRADUAL_SENDING: "Kademeli gönder",
    DELETE: "Sil",
    EDIT: "Düzenle",
    ADD: "Ekle",
  },
  MESSAGES: {
    SENDING_INTERVAL_QUESTION: "Her {time} sonra mesajlar gönderilsin mi?",
  },
  LABELS: {
    TIME_INTERVAL: "Zaman Aralığı",
    MESSAGE_COUNT: "Mesaj Sayısı",
  },
  TIME_TYPES: {
    MINUTE: "dakika",
    HOUR: "saat",
    DAY: "gün",
    WEEK: "hafta",
    SECOND: "saniye",
  },
  HINTS: {
    MESSAGE_COUNT_PER_PART: "Her gönderim partisindeki mesaj sayısını girin.",
  },
  RULES: {
    MESSAGE_COUNT_MIN_LIMIT: "Her partideki mesaj sayısı 500'den az olamaz!",
  },
  TABLE_HEADERS: {
    ROW: "Sıra",
    TITLE: "Başlık",
    STEP: "Adım",
    REMINDER_TIME: "Hatırlatma Zamanı",
    LAST_CALL_TIME: "Son Arama Zamanı",
    RECORDER: "Kaydeden",
    MANAGEMENT: "Yönetim",
    ID: "Kimlik",
    GROUP_NAME: "Grup Adı",
    PARENT: "Üst",
    CREATED_AT: "Oluşturuldu",
    IMAGE: "Fotoğraf",
    FULL_NAME: "Ad ve Soyad",
    EMAIL: "E-posta",
    PHONE_NUMBER: "Telefon Numarası",
    JOB_COMPANY: "İş Ünvanı ve Şirket",
    CREATION_TIME: "Oluşturma Zamanı",
    PHONEBOOK: "Telefon Rehberi",
    ACTIONS: "İşlemler",
    USER: "Kullanıcı",
  },
  PROPS: {
    SOURCE_NUMBER_LABEL: "Kaynak Numara",
  },
  MODAL: {
    INFO_TITLE: "Dikkat Edin.",
    INFO_MESSAGE_NEWS_NUMBER:
      '"{number}" kaynak numarası ile gönderimde minimum sayı 1000 olmalıdır.',
    CONFIRM_DELETE_GROUP: "Grubu silmeyi onayla?",
  },
  SPECIAL_NUMBERS: {
    NEWS_SEND: "Haber Gönderimi",
  },
  POPUP_TITLES: {
    SYSTEM_GUIDE: "Sistem Rehberi",
    ERROR: "Hata",
    WARNING: "Uyarı",
    SUCCESS: "Başarı",
    CONFIRM: "Onay",
    SELECT_GROUP: "Grup Seç",
    CREATE_NEW_GROUP: "Yeni Grup Oluştur",
    SELECT_GROUP_SUBGROUP: "Grup ve Alt Grup Seç",
    CREATE_DEFAULT_GROUP: "Varsayılan Grup Oluştur",
    DELETE_CONTACT_FROM_GROUP: "Kişiyi Gruptan Sil",
    DELETE_CONTACT: "Kişiyi Sil",
    SHARE_PHONEBOOK: "Telefon Rehberini Paylaş",
    SYSTEM_GUIDE: "Reklam Terminali Sistem Rehberi",
  },
  CARD_TITLES: {
    ENTER_GROUP_NAME: "İstediğiniz adı girin",
    SELECT_PERMISSIONS: "{name} telefon rehberi için erişim seç:",
    PEOPLE_WITH_ACCESS: "Erişimi Olan Kişiler",
  },
  LOADING_MESSAGES: {
    FETCHING_CATEGORIES: "Kategoriler yükleniyor...",
  },
  RADIO_LABELS: {
    GROUP_WITH_SUBGROUPS: "Grup alt gruplarla eklensin",
    SELECTED_GROUP_ONLY: "Sadece seçilen grup eklensin",
    DELETE_FROM_THIS_GROUP_ONLY: "Kişi sadece bu gruptan silinsin",
    DELETE_FROM_ALL_GROUPS: "Kişi tüm gruplardan silinsin",
  },
  FILTER_LABELS: {
    ADDRESS: "Adres",
    EMAIL: "E-posta",
    WEBSITE: "Web Sitesi",
    CUSTOM_FIELD: "Özel Alan",
    DATE: "Tarih",
  },
  CARD_SUBTITLES: {
    SHARE_INSTRUCTION:
      "Aşağıdakilerden herhangi birini seçerek istediğiniz erişimi başkalarıyla paylaşın.",
  },
  VALIDATION: {
    INVALID_PHONE_NUMBER: "Doğru telefon numarası girin",
  },
  LIST_ITEM_TITLES: {
    DELETE: "Sil",
    EDIT: "Düzenle",
    ADD: "Ekle",
    REMOVE_ACCESS: "Erişimi Kaldır",
  },
  CAMPAIGN: {
    CAMPAIGN_NAME: "Kampanya Adı",
    TEXT: "Metin",
    MESSAGE: "Mesaj",
    FOR: "İçin",
    SELECT_CAMPAIGN: "Kampanya Seç",
    CLICK_ROW: "İstediğiniz satıra tıklayın.",
    NEW: "Yeni",
    SUBMIT_CAMPAIGN: "Kampanya Kaydet",
    TIME: "Saat",
    MESSAGE_COUNT: "Mesaj Sayısı",
    PAGE_COUNT: "Toplam Mesaj (sayfa)",
    PAGE: "Sayfa",
    CANCEL_TEXT: "İptal11",
    TRACKABLE_LINK: "İzlenebilir Bağlantı",
    WARNING_TEXT: "Lütfen seçilen kampanyanın metin(lerini) düzeltin!",
    WARNING_TITLE: "Lütfen seçilen kampanyanın başlık(larını) düzeltin!",
    WARNING_GAP: "Lütfen seçilen kampanyanın zaman aralık(larını) düzeltin!",
    WARNING_OPERATOR: "Lütfen seçilen kampanyanın operatör(lerini) düzeltin!",
    MAX_ITEMS_ERROR: "En fazla 10 öğe eklenebilir.",
  },
  ADS: {
    LIVE_SMS: "Canlı SMS Gönderimi",
    BUY_JOB_DB: "Meslek Veritabanı Satın Al",
    SMART_LADDER: "Divar İlanı Akıllı Merdiven",
    JOB_SMS: "Mesleklere SMS Gönder",
    WEB_DESIGN: "Web Sitesi Tasarım Siparişi",
    SEO: "Site SEO Siparişi",
    MAP_SMS: "Haritadan SMS Gönder",
    GRADUAL_LADDER: "Divar İlanı Kademeli Merdiven",
    SEO_ALT: "Site SEO Siparişi",
    SITE_SUPPORT: "Site Yönetimi ve Destek",
    CITY_SMS: "Şehir ve İl SMS Gönderimi",
    AUTO_CHAT: "Divar Otomatik Sohbet",
  },
  TUTORIALS: {
    WHATSAPP_SUPPORT: "WhatsApp'ta İletişim",
    TICKET_SUPPORT: "Bilet Kaydet",
  },
  INCREASE: {
    PAN: "Kart Numarası",
    CVV2: "CVV2",
    MONTH: "Ay",
    YEAR: "Yıl",
    PIN2: "İkinci Şifre",
    GET_OTP: "İkinci Şifreyi Al",
    PAY: "Öde",
    INVALID_PAN: "Kart numarası yanlış",
    INVALID_CVV2: "CVV2 yanlış",
  },
  WALLET: {
    CustomCharge: "Cüzdan Şarj Et",
    withdrawTitle: "Cüzdandan Çek",
    transactionListTooltip: "İşlem listeniz",
    reloadTooltip: "Yenile",
    withdrawTooltip: "Cüzdandan Çek",
    AmountLabel: "Tutar ",
    SelectAmount: "Tutar Seç",
    Amount: "Tutar",
    Currency: "Riyal",
    GateWay: "Ödeme Geçidi",
    noGateWay: "Geçit bulunamadı",
    Pay: "Öde",
    PriceNotInRange: "Tutar {min} ile {max} arasında olmalıdır.",
    ErrorOnRedirectToGateWay: "Ödeme geçidine yönlendirilirken hata",
    ErrorGeneral: "Hata",
    MinAmountError: "Girilen tutar minimumdan az.",
    MinBazarAmountError: "Tutar 10.000 tomadan az olamaz!",
    BazarSuccessInfo:
      "Başarılı ödemede cüzdanınız 1-3 dakika içinde şarj olur.",
    withdrawableBalance: "Çekilebilir Bakiye",
    withdrawFee: "Çekim komisyonu: 50.000 riyal!",
    selectAccount: "Hesap Seç",
    addAccount: "Hesap Ekle",
    submitWithdraw: "Çekimi Onayla",
    accountRequiredInfo: "Tüm bilgiler zorunludur.",
    ownerName: "Hesap Sahibinin Adı",
    ownerLastName: "Soyadı",
    bankName: "Banka Adı",
    accountNumber: "Hesap Numarası",
    cardNumber: "Kart Numarası",
    sheba: "Şeba Numarası",
    onlyPersian: "Sadece Farsça harfler!",
    cardNumberLength: "Kart numarası 16 haneli olmalıdır!",
    shebaLength: "Şeba numarası 24 haneli olmalıdır!",
  },
  USER_PICKER: {
    SELECT_USER: "Kullanıcı Seç",
    SELECT_USERS: "Kullanıcılar Seç",
    SEARCH: "Ara",
    PERSON: "Gerçek Kişi",
    COMPANY: "Tüzel Kişi",
    ID: "Kimlik",
    NAME: "Ad",
    LASTNAME: "Soyad",
    USERNAME: "Kullanıcı Adı",
    PHONE: "Telefon",
    TYPE: "Kullanıcı Türü",
  },
  NEWS: {
    TITLE: "SMS Land Haberleri",
    VIEW_BUTTON: "Görüntüle",
    NO_NEWS: "Yeni haber yok.",
    FETCH_ERROR: "Haberler alınırken hata!",
  },
  MENUS: {
    CONTACT_LIST: "İletişim Listesi",
    FINDPREFIX: "Ön Ek Ara",
    // Sistemler
    TICKET_REGISTRATION: "Bilet Kaydet",
    AD_TERMINAL_SYSTEM: "Büyük Reklam Terminali Sistemi",
    WALLET_TRANSACTIONS: "Cüzdan İşlemleri",
    DYNAMIC_QR_SYSTEM: "Dinamik QR Oluşturma Sistemi",
    DIVAR_AD_SYSTEM: "Divar İlan Yerleştirme ve Yönetimi Sistemi",
    GRAPHIC_DESIGN_SYSTEM: "Grafik Tasarım ve Baskı Sipariş Sistemi",
    DIGITAL_MARKETING_SYSTEM: "Dijital Pazarlama Yönetim Sistemi",
    BULK_SMS_SYSTEM: "Toplu SMS Gönderim Sistemi",
    BUSINESS_INFO_SYSTEM: "Ülke Meslek Bilgi Bankası Sistemi",
    AD_MANAGEMENT_SYSTEM: "Reklam İlanı Yönetim Sistemi",
    GRAPHIC_VIDEO_SERVICES: "Grafik Tasarım ve Video Hizmetleri Sistemi",
    // QR Araçları
    QR_TOOL: "QR Aracı",
    CREATE_DYNAMIC_QR: "Dinamik QR Oluştur",
    QR_MANAGEMENT: "QR Yönetimi",
    QR_MONITORING: "QR İzleme",
    MY_QR_LIST: "QR'larım Listesi",
    PHYSICAL_NFC_ORDERS: "Fiziksel Kart ve NFC Siparişleri",
    BULK_QR_GENERATION: "Toplu QR Oluşturma",
    IMAGE_CREATION_TOKEN: "Resim Oluşturma Tokeni",
    QR_SMS: "QR SMS",
    QR_LINK: "QR Bağlantı",
    QR_TEXT: "QR Metin",
    QR_LOCATION: "QR Konum",
    QR_EMAIL: "QR E-posta",
    QR_CALL: "QR Arama",
    QR_WIFI: "QR Wi-Fi",
    VISIT_STATISTICS: "Ziyaret İstatistikleri",
    // İlan Yönetimi
    AD_MONITORING: "İlan İzleme",
    DIVAR_NEWS: "Divar Yenilikleri",
    REAL_ESTATE_AD_SUBMISSION: "Emlak Paneli İlan Gönderimi",
    AUTO_AD_RENEWAL: "İlanların Otomatik Yenilenmesi",
    GRADUAL_AD_SUBMISSION: "Kademeli İlan Gönderimi",
    SMART_AD_SUBMISSION: "Akıllı İlan Gönderimi",
    DEFAULT_AD_REGISTRATION: "Varsayılan İlan Kaydı",
    AD_ANALYZER: "İlan Ziyaret Analizörü",
    ADD_AD_PHOTO: "İlan Fotoğrafı Ekle",
    SMART_LADDER: "Akıllı Merdiven",
    GRADUAL_LADDER: "Kademeli Merdiven",
    ADS_LIST: "İlan Listesi",
    AD_REPORTS: "İlan Raporları",
    SCHEDULED_AD_SUBMISSION: "Zamanlı İlan Gönderimi",
    SCHEDULED_AD_LIST: "Zamanlı İlan Listesi",
    PERSONAL_AD_SUBMISSION: "Kişisel İlan Gönderimi",
    TARGET_TOOLS: "Hedefli Araçlar",
    SMART_LIST: "Akıllı/Kademeli Liste",
    // SMS
    SEND_TO_CUSTOMER_CLUB: "Müşteri Kulübüne Gönder",
    BULK_SMS: "Toplu SMS",
    LIVE_SMS: "Canlı SMS (eski)",
    SEND_TO_BUSINESSES: "Ülke Mesleklerine Gönder",
    SMS_BY_MAP: "Haritadan SMS Gönder",
    CITY_PROVINCE_SMS: "Şehir ve İl Gönderimi",
    RECEIVED_SMS_LIST: "Alınan SMS Listesi",
    SMS_TEXT_CONSULTANT: "SMS Metin Danışmanı İzleme",
    DEFAULT_TEXT_CONSULTATION: "Varsayılan Metin + Danışmanlık",
    ADMIN_SMS_SUBMISSIONS: "Yönetici Gönderimleri",
    PENDING_SMS: "Onay Bekleyen SMS",
    ADMIN_RECEIVED_REPORT: "Yönetici Alım Raporu",
    PATTERN: "Şablon/Pattern",
    SMS_REPORTS: "Gönderim Raporları",
    DEDICATED_LINE_REQUESTS: "Özel Hat Talepleri",
    PHONEBOOK: "Telefon Rehberi",
    SMS_TARIFFS: "SMS Tarifeleri",
    LINE_CATEGORIES: "Hat Kategorileri",
    TARIFF_COEFFICIENTS: "Gönderim Tarife Katsayıları",
    SEND_ADMIN_SMS: "Yönetici SMS Gönder",
    // Numaralar ve Kişiler
    ADD_NEW_NUMBER: "Yeni Numara Ekle",
    NUMBERS: "Numaralar",
    USER_NUMBERS: "Kullanıcı Numaraları",
    REGISTER_USER_NUMBER: "Kullanıcı için Numara Kaydet",
    NUMBER_LIST: "Numaralarım Listesi",
    CREATE_NUMBER_TARIFF: "Numara Tarifesi Oluştur",
    NUMBER_TARIFF_LIST: "Numara Tarifeleri Listesi",
    OTHER_TARIFF_LIST: "Diğer Tarifeler Listesi",
    // Finansal Yönetim
    WALLET: "Yeni Cüzdan",
    TRANSFER_REQUESTS: "Çekim Talepleri",
    DIVAR_PAYMENTS: "Divar Ödemeleri",
    AUTO_PAYMENT: "Otomatik Ödeme",
    PAYMENTS: "Ödemeler",
    PAYMENT_GATEWAY: "Ödeme Geçidi",
    BUY_CHARGE: "Şarj Satın Al",
    // Müşteri ve Kullanıcı Yönetimi
    CUSTOMERS: "Müşteriler",
    CRM_CUSTOMERS: "CRM Müşterileri",
    CONTACT_LIST: "İletişim Yardımcısı (İletişim Teşekkürü)",
    USERS: "Kullanıcı Listesi",
    USER_REQUESTS: "Kullanıcı Talepleri",
    PROFILE: "Profil",
    USER_HISTORY_NOTIFICATIONS: "Kullanıcı Geçmiş Bildirimleri",
    // Tasarım ve İçerik
    WEBSITE_DESIGN_ORDER: "Web Sitesi Tasarım Siparişi",
    SEO_ORDER: "Site SEO Siparişi",
    BUY_INFO_DATABASE: "Bilgi Bankası Satın Al",
    BUY_MOBILE_DATABASE: "Mobil Numara Bankası Satın Al",
    PURCHASED_ARCHIVES: "Satın Alınan Arşivler",
    FAVORITE_ARCHIVES: "Favori Arşivler",
    UPLOAD_CENTER: "Yükleme Merkezi",
    CONTENT: "İçerik",
    // Yönetim ve Ayarlar
    MONITORING: "İzleme",
    MANAGEMENT: "Yönetim",
    SETTINGS: "Ayarlar",
    CATEGORIES: "Kategoriler",
    DOMAINS: "Alan Adları",
    REMINDERS: "Hatırlatmalar",
    AUTOMATIC_CREATION: "Otomatik Oluşturma",
    PERMISSIONS: "İzinler",
    ROLES: "Roller",
    MENUS: "Menüler",
    CORE_MANAGEMENT: "Çekirdek Yönetim",
    WORK_REPORTS: "İş Raporu Yönetimi",
    WORK_REPORT_CREATE: "İş Raporu",
    DEPARTMENTS: "Departmanlar",
    DISCOUNTS: "İndirimler",
    NOTIFICATIONS: "Bildirimler",
    ADMIN_NOTIFICATIONS: "Yönetici Bildirimleri",
    TICKET_MANAGEMENT: "Bilet Yönetimi",
    USER_GUIDE: "Kullanıcı Rehberi",
    CAMPAIGN: "Kampanya",
    MESSAGE_CATEGORIES: "Mesaj Kategorileri",
    REGISTERED_INFO_LIST: "Kayıtlı Bilgi Listesi",
    TARIFFS: "Tarifeler",
    INFORMATION_REGISTRATION: "Bilgi Kaydı",
    UNCREATED_CARDS: "Oluşturulmamış Kartlar",
    MODELS_LIST: "Model Listesi",
    CREATE_DEFAULT_PRODUCT: "Varsayılan Ürün Oluştur",
    EXCEL_FILES: "Excel Dosyaları",
    AUTO_CHATS: "Akıllı Sohbet",
    AUTO_CHAT: "Otomatik Sohbet",
    // Diğer
    MY_FILES: "Dosyalarım",
    CONSULTANTS: "Danışmanlar",
    ADD_DIVAR_NEWS: "Divar Yenilikleri Ekle",
    BUY_PANEL: "Panel Satın Al",
    PANELS: "Paneller",
    CALL_MONITORING: "Arama İzleme",
    INFO_REVIEW: "Bilgi İncelemesi",
    MESSAGES: "Mesajlar",
    PERSONNEL: "Personel",
    //qr
    QR_TOOL: "QR Aracı",
    CREATE_DYNAMIC_QR: "Dinamik QR Oluştur",
    QR_MANAGEMENT: "QR Yönetimi",
    QR_MONITORING: "QR İzleme",
    MY_QR_LIST: "QR'larım Listesi",
    PHYSICAL_NFC_ORDERS: "Fiziksel Kart ve NFC Siparişleri",
    BULK_QR_GENERATION: "Toplu QR Oluşturma",
    IMAGE_CREATION_TOKEN: "Resim Oluşturma Tokeni",
    CATEGORIES: "Kategoriler",
    CREATE_DEFAULT_PRODUCT: "Varsayılan Ürün Oluştur",
    DOMAINS: "Alan Adları",
    REMINDERS: "Hatırlatmalar",
    AUTOMATIC_CREATION: "Otomatik Oluşturma",
    SEND_ADMIN_SMS: "Yönetici SMS Gönder",
    UNCREATED_CARDS: "Oluşturulmamış Kartlar",
    MODELS_LIST: "Model Listesi",
    UPLOAD_CENTER: "Yükleme Merkezi",
    INFORMATION_REGISTRATION: "Bilgi Kaydı",
    TARIFFS: "Tarifeler",
    REGISTERED_INFO_LIST: "Kayıtlı Bilgi Listesi",
    //code
    personel: "Personel",
    "workReports/create": "İş Raporu",
    "admin/user-guide": "Kullanıcı Rehberi",
    phonebook: "Müşteri Kulübü",
    contactlist: "İletişim Yardımcısı (İletişim Teşekkürü)",
    "contact/list": "İletişim Yardımcısı (İletişim Teşekkürü)",
    "admin/transferRequests": "Çekim Talepleri",
    "admin/wallet": "Yeni Cüzdan",
    "admin/cdr": "Arama İzleme",
    "admin/campaign": "Kampanya",
    "admin/message-categories": "Mesaj Kategorileri",
    "admin/customers": "CRM Müşterileri",
    "admin/notifications": "Yönetici Bildirimleri",
    "admin/user-history/notifications": "Kullanıcı Geçmiş Bildirimleri",
    "admin/messages": "Mesajlar",
    profile: "Profil",
    "admin/workReports": "İş Raporu Yönetimi",
    panel: "Panel Satın Al",
    adminDiscounts: "İndirimler",
    departments: "Departmanlar",
    adminTickets: "Bilet Yönetimi",
    "admin/configs": "Ayarlar",
    notifications: "Bildirimler",
    "user/confirmed": "Kullanıcı Talepleri",
    users: "Kullanıcı Listesi",
    payments: "Ödeme Geçidi",
    permission: "İzinler",
    panels: "Paneller",
    category: "Menüler",
    content: "İçerik",
    role: "Roller",
    "core/admin": "Çekirdek Yönetim",
    //robot
    numberList: "Numaralarım Listesi",
    registerAd: "İlan Kaydet",
    proPanelSendAd: "Profesyonel Panel İlan Gönder",
    buyCharge: "Şarj Satın Al",
    scheduledAdSend: "Zamanlı İlan Gönderimi",
    smartGradual: "Akıllı/Kademeli",
    createNumberTariff: "Numara Tarifesi Oluştur",
    numberTariffList: "Numara Tarifeleri Listesi",
    otherTariffList: "Diğer Tarifeler Listesi",
    userNumbers: "Kullanıcı Numaraları",
    numbers: "Numaralar",
    management: "Yönetim",
    settings: "Ayarlar",
    registerUserNumber: "Kullanıcı için Numara Kaydet",
    divarPayments: "Divar Ödemeleri",
    autoPayment: "Otomatik Ödeme",
    adAnalyzer: "İlan Ziyaret Analizörü",
    infoReview: "Bilgi İncelemesi",
    rb_payments: "Ödemeler",
    autoChat: "Otomatik Sohbet",
    ads: "İlanlar",
    monitoring: "İzleme",
    smartLadder: "Akıllı Merdiven",
    gradualLadder: "Kademeli Merdiven",
    excelFiles: "Excel Dosyaları",
    autoChats: "Akıllı Sohbet",
    addAdPhoto: "İlan Fotoğrafı Ekle",
    targetTools: "Hedefli Araçlar",
    smartList: "Akıllı/Kademeli Liste",
    scheduledAdList: "Zamanlı İlan Listesi",
    adsList: "İlan Listesi",
    adReports: "İlan Raporları",
    personalAdSend: "Kişisel İlan Gönderimi",
  },
  AUTO_REFRESH_POPUP: {
    TITLE: "İstediğiniz zamanı girin:",
    SUBTITLE:
      "Zaman belirlendikten sonra bu sayfa seçilen zamanda her zaman yenilenecek.",
    TIME_LABEL: "Zaman",
  },
  MODAL: {
    OK_TITLE: "Onayla",
  },

  ROUTE: {
    TITLES: {
    QR_NAME_EDIT_TEXT: "QR metnini düzenle",
    SERVER_DOWN: "Güncelleniyor",
    CREATE_MEMORIES_MODEL: "Anı Çerçevesi Şablonu Oluştur",
    CREATE_CARD_VISIT_PRO_MODEL: "Kartvizit Pro Şablonu Oluştur",
    CREATE_PRODUCT_PRO_MODEL: "Ürün Tanıtım Pro Şablonu Oluştur",
    CREATE_PRODUCT_LABEL_MODEL: "Ürün Etiketi Şablonu Oluştur",
    CREATE_PHOTO_GALLERY_MODEL: "Fotoğraf Galerisi Şablonu Oluştur",
    CREATE_PDF_GALLERY_MODEL: "PDF Galerisi Şablonu Oluştur",
    CREATE_SOCIAL_MEDIA_MODEL: "Sosyal Medya Şablonu Oluştur",
    EDIT_CARD_VISIT_PRO_MODEL: "Kartvizit Pro Şablonunu Düzenle",
    EDIT_PRODUCT_PRO_MODEL: "Ürün Tanıtım Pro Şablonunu Düzenle",
    EDIT_PRODUCT_LABEL_MODEL: "Ürün Etiketi Şablonunu Düzenle",
    EDIT_PHOTO_GALLERY_MODEL: "Fotoğraf Galerisi Şablonunu Düzenle",
    EDIT_PDF_GALLERY_MODEL: "PDF Galerisi Şablonunu Düzenle",
    EDIT_SOCIAL_MEDIA_MODEL: "Sosyal Medya Şablonunu Düzenle",
    BOOK: "Kitap",
    NFC_LIST: "NFC Listesi",
    API_KEY_MANAGER: "API Anahtarı Oluştur",
    PRE_PURCHASE: "Ön Satın Alma",
    PRE_PURCHASE_MODEL: "Hazır Şablon",
      "QR_NAME_EDIT_GIFT": "Hediye QR Kodunu Düzenle",
     "QR_GIFT": "Hediye QR Kodu",
      QR_CARD_VISIT_PRO:"Pro Bağlantı QR Kodunu",
      "QR_NAME_EDIT_PRO": "Pro Bağlantı QR Kodunu Düzenle",
      "QR_LINK_EDIT_PRO": "SEO Tıklama Asistanı QR'ını Düzenle",
      "QR_LINK_PRO": "SEO Tıklama Asistanı QR",
      DIGI: "Digikala Fiyat Monitörü",
      QR_PDF: "PDF Galerisi",
      QR_NAME_EDIT_PDF: "PDF Galerisini Düzenle",
      QR_MULTICART: "Çoklu QR Kartı",
      QR_MULTICART_EDIT: "Çoklu QR Kartını Düzenle",
      QR_PRODUCTPRO: "Ürün Tanıtımı (Pro)",
      QR_NAME_PRODUCTPRO: "Ürün Tanıtımını Düzenle (Pro)",
      QR_NAME_EDIT_CATALOG: "Kataloğu Düzenle",
      QR_LUCK_WHEEL_Edit: "Şans Çarkını Düzenle",
      QR_LUCK_WHEEL: "Şans Çarkı QR Kodu Oluştur",
      DASHBOARD: "Gösterge Paneli",
      ADMIN_QR_DOMAINS: "Alan Adı İzleme",
      ADMIN_TOGETHER_TOKEN: "Token İzleme",
      ADMIN_QR_SMS: "SMS Gönderim",
      MENU_PROFILE_INFO: "Kullanıcı Bilgileri",
      MENU_PROFILE_SETTING: "Profil Ayarları",
      MENU_PROFILE_ORDERS: "Siparişler",
      MENU_PROFILE_ADDRESSES: "Adresler",
      QR_MONITORING: "QR İzleme",
      QR_LIST: "QR'larım Listesi",
      QR_NAME_LIST: "Katılım Yönetimi",
      QR_GENERATE_MULTIPLE: "Toplu QR Oluşturma",
      QR_CARD_VISIT: "Kartvizit Oluştur",
      HELP_INFO: "Buton Testi",
      QR_MENU: "Mağaza Menüsü",
      QR_APPOINTMENT: "Randevu",
      QR_INSURANCE: "Online Sigorta Oluştur",
      QR_BPAGE: "İş Sayfası Oluştur",
      QR_CPAGE: "Ticari/İdari Kompleks Sitesi Oluştur",
      QR_BSHOP: "Online Mağaza",
      QR_NAME_EDIT_BSHOP: "Online Mağaza Düzenle",
      QR_LINK_EDIT: "Bağlantı Düzenle",
      QR_NAME_DESIGN: "Tasarım Düzenle",
      QR_NAME_SETTING: "Ayarlar Düzenle",
      QR_NAME_EDIT: "Kartvizit Düzenle",
      QR_NAME_EDIT_BPAGE: "İş Sayfası Düzenle",
      QR_EDIT_CPAGE: "Kompleks Sitesi Düzenle",
      QR_NAME_INSURANCE: "Online Sigorta Düzenle",
      QR_NAME_EDIT_MENU: "Menü Düzenle",
      QR_NAME_EDIT_APPLICATION: "Uygulama Sun",
      QR_NAME_EDIT_APPOINTMENT: "Randevu Düzenle",
      QR_NAME_EDIT_PHOTO: "Foto Galeri Düzenle",
      QR_NAME_EDIT_VIDEO: "Video Galeri Düzenle",
      QR_NAME_EDIT_VOICE: "Ses Galeri Düzenle",
      QR_NAME_EDIT_FEEDBACK: "Geri Bildirim Galeri Düzenle",
      QR_NAME_CONSULTATION_QR_EDIT: "Talep Formu Düzenle",
      QR_NAME_EDIT_VOICE_PRO: "Ses Galeri Düzenle (pro)",
      QR_NAME_EDIT_SOCIAL: "Sosyal Medya Düzenle",
      QR_NAME_STATISTICS: "QR Kodu İstatistikleri",
      QR_CATE: "Kategori Seç",
      QR_SHARE: "Paylaş",
      QR_BUSINESS_SHOP: "İş/Mağaza",
      QR_CO_ORGAN: "Şirket/Organizasyon",
      QR_CONTACT: "Müşteri İletişimi",
      QR_NOTICES: "Bildirimler",
      QR_OTHERS: "Diğer",
      QR_STATICS: "Statik QR",
      QR_DYNAMICS: "Dinamik QR",
      QR_D_BUSINESS: "Dinamik İş QR",
      QR_D_ORGANS: "Dinamik Organizasyon QR",
      QR_D_GOVERNMENT: "Dinamik Devlet QR",
      QR_VIDEO: "Video Galeri",
      QR_APPLICATION: "Uygulama Sun",
      QR_VOICE: "Ses Galeri",
      QR_VOICE_PRO: "Ses Galeri (pro)",
      QR_CONSULTATION_QR: "Talep Formu",
      QR_FEEDBACK: "Geri Bildirim Galeri",
      QR_PHOTO: "Foto Galeri",
      QR_CATALOG: "Katalog / Broşür",
      QR_LOCATION: "Konum QR Oluştur",
      QR_SOCIAL_MEDIA: "Sosyal Medya QR Oluştur",
      QR_LINK: "Bağlantı Oluştur",
      QR_TEXT: "Metin Oluştur",
      QR_MAIL: "E-posta Oluştur",
      QR_CALL: "Arama",
      QR_SMS: "SMS",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "Web Sitesi",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "İş Sayfası",
      QR_DISCOUNT: "İndirim Sayfası",
      QR_PRODUCT_SHOP: "Ürün Tanıtımı",
      QR_PRODUCT_LABEL: "Ürün Etiketi",
      QR_GOLD_LABEL: "Altın Etiket",
      QR_PRODUCT_TEMPLATE: "Ürünler",
      ADMIN_CATEGORY: "Kategoriler",
      QR_NFC_ORDERS: "Onay Bekleyen NFC Kartlar",
      QR_NAME_PRODUCT: "Ürün Tanıtımı Düzenle",
      QR_NAME_LABELPRODUCT: "Ürün Etiketi Düzenle",
      QR_NAME_GOLDPRODUCT: "Altın Etiket Düzenle",
      QR_COINS: "Kripto Paralar",
      QR_SHOP: "Mağaza Yönetimi",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "Yükleme Merkezi",
      PRICING: "QR Tarifeleri",
      QR_CREATE_MODELS: "Kartvizit Modeli Oluştur",
      QR_CREATE_BUSINESS_MODELS: "İş Sayfası Modeli Oluştur",
      QR_CREATE_PRODUCT_MODEL: "Ürün Kartı Modeli Oluştur",
      QR_CREATE_MENU_MODELS: "Mağaza Menüsü Modeli Oluştur",
      QR_CREATE_SHOP_MODEL: "Online Mağaza Modeli Oluştur",
      MODELS_LIST: "QR Model Türleri",
      MODELS_LIST_EDIT: "Model Düzenle",
      MODELS_LIST_MENU_EDIT: "Menü Modeli Düzenle",
      MODELS_LIST_BMODEL_EDIT: "Online Mağaza Modeli Düzenle",
      NFC: "NFC Kartlar",
      SUBMIT_FORM: "Blogger Kaydet",
      REQUEST_LIST: "Blogger Listesi",
      PURE_DATA: "Oluşturulmamış Kartvizit Listesi",
      AUTO_CREATE: "Otomatik QR Oluştur",
      QR_CREATE: "QR Oluştur",
      HISTORY_REMINDER: "Hatırlatma İzleme",
      BOOK: "Hatırlatma İzleme"
    },
  },
  qr_management: "QR Yönetimi",
  router: {
    dashboard: "Gösterge Paneli",
    contacts: "Müşteri Kulübü",
    editContact: "Müşteri Düzenle",
    createContact: "Müşteri Oluştur",
    customers: "Müşteri Listesi",
    contactList: "İletişim Yardımcısı",
    messages: "Mesajlar",
    messageCategories: "Mesaj Kategorileri",
    oldTransactions: "Eski İşlemler",
    yourTransactions: "İşlemleriniz",
    buyPanel: "Panel Satın Al",
    permissions: "Erişimler",
    createPermission: "İzin Oluştur",
    invitations: "Davet Listem",
    editUser: "Kullanıcı Düzenle",
    userInformation: "Kullanıcı Bilgilerini Görüntüle",
    walletEdit: "Kullanıcı Cüzdan Bilgilerini Düzenle",
    userHistory: "Kullanıcı Geçmişi",
    userNotificationsHistory: "Kullanıcı Bildirim Geçmişi",
    notifications: "Bildirimler",
    createNotification: "Bildirim Oluştur",
    editNotification: "Bildirim Düzenle",
    adminNotifications: "Yönetici Bildirimleri",
    yourNotifications: "Bildirimleriniz",
    adminNotificationsList: "Yönetici Bildirim Listesi",
    tickets: "Biletler",
    createTicket: "Yeni Bilet Kaydet",
    editTicket: "Bilet Düzenle",
    departments: "Departmanlar",
    createDepartment: "Yeni Departman",
    editDepartment: "Departman Düzenle",
    adminTickets: "Bilet Yönetimi",
    discounts: "İndirimler",
    createDiscount: "İndirim Oluştur",
    editDiscount: "İndirim Düzenle",
    workReports: "İş Raporu",
    createWorkReport: "İş Raporu Oluştur",
    callMonitoring: "Arama İzleme",
    adminWorkReports: "İş Raporu Yönetimi",
    editWorkReport: "İş Raporunu Görüntüle ve Düzenle",
    packProperties: "Paket Özellikleri",
    createPackProperty: "Paket Özelliği Oluştur",
    editPackProperty: "Paket Özelliği Düzenle",
    panels: "Paneller",
    createPanel: "Panel Oluştur",
    editPanel: "Panel Düzenle",
    transferRequests: "Çekim Talepleri",
    editTransferRequest: "Çekim Talebini Düzenle",
    tariffs: "Tarifeler",
    createTariff: "Tarife Oluştur",
    editTariff: "Tarife Düzenle",
    requests: "Talepler",
    viewUser: "Kullanıcı Görüntüle",
    manageTransactions: "İşlem Yönetimi",
    viewTransaction: "İşlem Görüntüle",
    manageConfigs: "Ayar Yönetimi",
    rbLandConfigs: "Robot Land Ayar Yönetimi",
    editConfig: "Ayar Düzenle",
    manageUsers: "Kullanıcı Yönetimi",
    categories: "Kategoriler",
    createCategory: "Kategori Ekle",
    editCategory: "Kategori Düzenle",
    content: "İçerik",
    createContent: "İçerik Ekle",
    editContent: "İçerik Düzenle",
    addUserGuide: "Kullanıcı Rehberi Ekle",
    editUserGuide: "Kullanıcı Rehberi Düzenle",
    roles: "Roller",
    editRole: "Rol Düzenle",
    createRole: "Rol Ekle",
    permissionTitle: "Erişimler",
    paymentGateways: "Ödeme Geçitleri",
    editPaymentGateway: "Ödeme Geçidi Düzenle",
    campaigns: "Kampanyalar",
    createCampaign: "Kampanya Oluştur",
    editCampaign: "Kampanya Bilgilerini Düzenle",
    adminCustomers: "Müşteriler",
    createCustomer: "Müşteri Oluştur",
    editCustomerInfo: "Müşteri Bilgilerini Düzenle",
    referrerCustomers: "Tavsiye Eden Müşteriler",
    customerHistory: "Müşteri Geçmişi",
    userProfile: "Kullanıcı Profili",
    editProfile: "Profil Düzenle",
    inviteFriends: "Arkadaş Davet Et",
    personalInfo: "Kişisel Bilgiler",
    editPersonalInfo: "Bilgileri Düzenle",
    changePassword: "Şifre Değiştir",
    newWallet: "Yeni Cüzdan",
  },
  ticket: {
    text: "Bilet Kaydet",
  },
};
